import * as React from "react"
import { Link } from "gatsby"
import LogoFooter from "../images/logotype.inline.svg"
import NewMessage from "../images/newMessage.inline.svg"
import Love from "../images/love.inline.svg"

const Footer = () => {
  const year = new Date().getFullYear()

  return (
    <div id="footer" className="footer">
      <div className="container">
        <div className="footer-card">
          <div className="footer-content-wrap">
            <div className="title">Напишите мне</div>
            <h3 className="footer-h2">
              Есть вопросы и предложения? Напишите на email!
            </h3>
            <div className="footer-mail-wrap">
              <NewMessage className="mail-icon" />
              <div className="footer-email">
                <a href="mailto:hello@nesvyataya.com">hello@nesvyataya.com</a>
              </div>
            </div>
          </div>
          <div className="footer-link-wrap">
            <div className="footer-logo">
              <Link to="/">
                <LogoFooter style={{ width: 70 }} />
              </Link>
            </div>
            <div className="nav-menu-footer">
              <Link to="#1" aria-current="page" className="nav-link">
                Политика конфиденциальности
              </Link>
              <Link to="#2" aria-current="page" className="nav-link">
                Юридические данные
              </Link>
              <Link to="#3" aria-current="page" className="nav-link">
                Договор оферты
              </Link>
            </div>
          </div>
        </div>
        <div className="legal-text-wrap">
          <div className="footer-legal-text">
            © {year} <b>«НЕСВЯТАЯ».</b> Fitness project by Daria Starikova.{" "}
            <br />
            <br />
            <a
              href="https://lapkov.com/ru/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontSize: "14px",
              }}
            >
              Made with <Love style={{ width: 15, height: 15 }} />
            </a>
          </div>
          <div className="footer-links">
            <a
              href="https://www.instagram.com/starikova.dar/"
              className="template-link"
            >
              Instagram
            </a>
            <a
              href="https://www.facebook.com/dasha.starikova.7"
              className="template-link"
            >
              Facebook
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
